export default __webpack_public_path__ + "static/media/activate-1.be79907b.png";